//create enum
export enum LangEnum {
  claims = 'Claims',
  work = 'Work',
  settings = 'Settings',
  autocheck = 'AutoCheck',
  batchprocessing = 'Batch Processing',
}
